import Vue from "vue";
import Vuex from "vuex";
import { hosts, defaultHost } from "@/helpers/hosts";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    hosts: hosts(),
    selectedHost: defaultHost(),
    loading: false,
  },
  mutations: {
    changeHost(state, host) {
      state.selectedHost = host;
    },
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
  },
  actions: {},
  modules: {},
});
